export default __webpack_public_path__ + "static/media/maxine_detail14.8002b0c6.jpg";